export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9013.6b9a7ff1.jpg";